export default "__VITE_ASSET__C3y8Jnlh__"